import { createSlice } from "@reduxjs/toolkit";

const initial = {
  value: JSON.parse(localStorage.getItem("frejun-locations")),
};
localStorage.setItem("frejun-locations", JSON.stringify(initial.value));

export const locationsSlice = createSlice({
  name: "locations",
  initialState: initial,
  reducers: {
    setLocations: (state, action) => {
      state.value = action.payload;
      localStorage.setItem("frejun-locations", JSON.stringify(state.value));
    },
  },
});

export const { setLocations } = locationsSlice.actions;
export default locationsSlice.reducer;
